import {useSelector} from 'react-redux';

export default function useParamSelector(selector, ...params) {
  return useSelector((state) => selector(state, ...params));
}
